module.exports = __webpack_public_path__ + "static/part-14-1d6d5d2d23ca561126e6d4aab60e126f.svg";